module.exports = __webpack_public_path__ + "static/media/art35.9e57375d.jpg";